import { useBraidTheme } from "../BraidProvider/BraidThemeContext.mjs";
const useColor = () => {
  const {
    foreground,
    // TODO: COLORMODE RELEASE
    // Release new backgrounds
    background: { surfaceDark: _, bodyDark: __, ...background }
  } = useBraidTheme().color;
  return {
    foreground,
    background
  };
};
export {
  useColor
};
